import { DeleteAdminMutation } from "@/generated/graphql_billing";
import { graphql, HttpResponse } from "msw";

export const deleteAdminMutationHandler = graphql.mutation<DeleteAdminMutation>(
  "deleteAdmin",
  ({ query, variables }) => {
    return HttpResponse.json(
      {
        data: {
          deleteAdmin: {
            result: true,
          },
        },
      }
      // ctx.errors([
      //   {
      //     extensions: {
      //       code: ErrorCode[ErrorCode.INTERNAL_SERVER_ERROR],
      //     },
      //   },
      // ])
    );
  }
);
